export default "__VITE_ASSET__Co39NfHO__"